import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const BabyIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <g>
                <path fill="currentColor" d="M11.584,21.95c-3.556,0-6.787-1.96-8.432-5.116c-0.191-0.367-0.049-0.82,0.318-1.012
                    c0.366-0.191,0.82-0.048,1.012,0.318c1.386,2.658,4.106,4.31,7.102,4.31c2.742,0,5.263-1.381,6.744-3.694
                    c0.224-0.348,0.688-0.452,1.036-0.227c0.349,0.223,0.45,0.687,0.228,1.036C17.833,20.311,14.84,21.95,11.584,21.95z"/>
            </g>
            <g>
                <path fill="currentColor" d="M2.858,12.524c-0.02,0-0.038,0-0.058-0.002c-0.413-0.032-0.723-0.392-0.691-0.805
                    c0.374-4.919,4.536-8.772,9.475-8.772c0.489,0,0.98,0.038,1.461,0.112c0.409,0.063,0.69,0.446,0.627,0.855
                    c-0.063,0.41-0.443,0.69-0.855,0.627c-0.405-0.062-0.819-0.094-1.232-0.094c-4.159,0-7.664,3.244-7.979,7.386
                    C3.575,12.225,3.247,12.524,2.858,12.524z"/>
            </g>
            <g>
                <path fill="currentColor" d="M3.664,16.958c-1.426,0-2.574-0.937-2.925-2.388c-0.337-1.396,0.588-2.968,1.94-3.298
                    c0.396-0.098,0.808,0.148,0.906,0.55s-0.148,0.809-0.551,0.907c-0.493,0.121-0.988,0.865-0.838,1.489
                    c0.188,0.776,0.736,1.24,1.467,1.24c0.414,0,0.75,0.336,0.75,0.75S4.078,16.958,3.664,16.958z"/>
            </g>
            <g>
                <path fill="currentColor" d="M19.294,17.698c-0.067,0-0.135-0.002-0.204-0.006c-0.413-0.023-0.729-0.378-0.706-0.792
                    c0.024-0.414,0.378-0.743,0.792-0.706c0.374,0.015,1.276-0.043,1.524-1.109c0.199-0.853-0.159-1.465-0.617-1.629
                    c-0.39-0.14-0.593-0.569-0.453-0.959c0.139-0.39,0.567-0.594,0.959-0.453c1.263,0.453,1.924,1.875,1.572,3.382
                    C21.835,16.823,20.722,17.697,19.294,17.698z"/>
            </g>
            <g>
                <circle fill="currentColor" cx="8.625" cy="12.375" r="1.125"/>
            </g>
            <g>
                <circle fill="currentColor" cx="14.625" cy="12.375" r="1.125"/>
            </g>
            <g>
                <path fill="currentColor" d="M20.336,13.198c-0.414,0-0.75-0.336-0.75-0.75c0-2.53-0.79-4.38-2.562-5.998l-0.919-0.838l1.171-0.421
                    c0.006-0.002,0.93-0.363,0.831-0.909c-0.059-0.327-0.227-0.614-0.407-0.842c-0.44,0.525-1.164,1.102-2.253,1.17l-0.31,0.02
                    c-0.803,0.053-1.041,0.061-2.36-0.097c-0.411-0.049-0.705-0.422-0.656-0.833c0.05-0.411,0.418-0.713,0.834-0.656
                    c1.229,0.146,1.378,0.138,2.083,0.089l0.315-0.021c1.051-0.066,1.493-1.081,1.511-1.124l0.355-0.837l0.757,0.502
                    c0.138,0.093,1.354,0.948,1.607,2.363c0.162,0.901-0.295,1.583-0.841,2.033c1.595,1.75,2.344,3.808,2.344,6.398
                    C21.086,12.862,20.75,13.198,20.336,13.198z"/>
            </g>
            <g>
                <path fill="currentColor" d="M13.222,4.523c0,0,2.288,0.572,3.379,1.461c0.377,0.308,1.413,0.272,1.346,0.212
                    c0,0,1.911-2.524,0.881-3.556s-1.065-0.838-1.065-0.838s-0.715,1.115-0.984,1.49C16.51,3.668,13.222,4.523,13.222,4.523z"/>
            </g>
        </SvgIcon>
    );
};
